<template>
  <q-card flat bordered class="text-center" :key="rsiValue">
    <div v-if="rsiValue !== null">
      <vue-gauge ref="gauge" :options="chartOptions" />
      <div class="text-body2 text-bold">Confidence Level</div>
    </div>
  </q-card>
</template>

<script setup>
import { ref, reactive, watch } from "vue";
import VueGauge from "vue-gauge";

import useData from "src/use/data";
const props = defineProps({
  symbol: {
    type: String,
    required: true,
  },
});

const { indicators } = useData();
const rsiValue = ref(null);

const chartOptions = reactive({
  chartWidth: 375,
  needleValue: null,
  needleColor: "#000000",
  arcDelimiters: [20, 40, 60, 80],
  arcLabels: ["20", "40", "60", "80"],
  arcColors: ["#ff0000", "#feee00", "#009aff", "#01ce00", "#01aa20"],
  hasNeedle: true,
  arcOverEffect: true,
  arcPadding: 0.1,
  arcPaddingColor: "#0000ff",
});

function getData(symbol) {
  if (symbol === null) {
    return
  }
  indicators(symbol).then(async (res) => {
    rsiValue.value = await res.data[0]?.rsi14;
    chartOptions.needleValue = rsiValue.value;
  });
}

watch(
  () => props.symbol,
  (newVal, oldVal) => {
    if (newVal !== oldVal){
      getData(newVal);
    }
  }, 
  { immediate: true }
);

</script>
